<template>
  <div style="margin: 2rem;">
    <div class="container" style="max-width: 1000px;">
      <div class="container has-text-centered" style="max-width: 900px; margin-bottom: 4rem;">
        <h2 class="is-size-5">
          404: <translate>notFound</translate>
        </h2>
        <div style="padding: 1rem;">
          <router-link v-if="this.$leurisMode === 'PORTAL'" class="button is-primary" to="welcome">
            <translate>btn.back</translate>
          </router-link>
          <router-link v-else class="button is-primary" to="/">
            <translate>btn.back</translate>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicTitle from '@/components/mixins/DynamicTitle'

export default {
  name: 'NotFound',
  mixins: [DynamicTitle],
  data () {
    return {
      msg: 'UL Forschungsbericht',
      leurisHead: {
        inner: 'leuris:Forschungsportal',
        complement: 'notFound'
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue